import { useContext } from 'react'
import { NotificationsUiContext } from './NotificationsUiContext'

export function useNotificationsUi() {
  const ctx = useContext(NotificationsUiContext)
  if (!ctx) throw new Error('useNotificationsUi must be used within NotificationsUiProvider')
  return ctx
}
